// @flow
import CreateInvoicePaymentModal from './CreateInvoicePaymentModalContainer';
export default CreateInvoicePaymentModal;
